
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Clock, XCircle, PlayCircle } from 'lucide-react';

interface RentalStatusBadgeProps {
  status: string;
  className?: string;
}

export const RentalStatusBadge: React.FC<RentalStatusBadgeProps> = ({ 
  status,
  className 
}) => {
  switch (status.toLowerCase()) {
    case 'completed':
      return (
        <Badge variant="success" className={className}>
          <CheckCircle2 className="h-3 w-3 mr-1" />
          Завершена
        </Badge>
      );
    case 'active':
      return (
        <Badge variant="info" className={className}>
          <PlayCircle className="h-3 w-3 mr-1" />
          Активна
        </Badge>
      );
    case 'pending':
      return (
        <Badge variant="warning" className={className}>
          <Clock className="h-3 w-3 mr-1" />
          Ожидает
        </Badge>
      );
    case 'cancelled':
      return (
        <Badge variant="destructive" className={className}>
          <XCircle className="h-3 w-3 mr-1" />
          Отменена
        </Badge>
      );
    default:
      return (
        <Badge variant="secondary" className={className}>
          {status}
        </Badge>
      );
  }
};
